import React, { useState } from "react";
import { DataTable, DataTableRowEditCompleteParams } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import { InputText } from "primereact/inputtext";
import { YAxisIdentifier, YAxisIdentifierWithOverriddenTitle } from "./interfaces";

interface ChartIdentifiersEditorProps {
  currentConfig: YAxisIdentifier[];
  setCurrentConfig: (config: YAxisIdentifier[]) => void;
}

const ChartIdentifiersEditor = ({
  currentConfig,
  setCurrentConfig,
}: ChartIdentifiersEditorProps) => {
  const [identifiers, setIdentifiers] = useState<YAxisIdentifier[]>(
    currentConfig.map(item =>
      typeof item === "string" ? { identifier: item, overriddenTitle: "" } : item
    )
  );

  const titleBodyTemplate = (rowData: YAxisIdentifierWithOverriddenTitle) => {
    return <DatasetTitle identifier={rowData.identifier} />;
  };

  const textEditor = (options: ColumnEditorOptions) => {
    return (
      <InputText
        value={options.value || ""}
        onChange={e => options.editorCallback?.(e.target.value)}
        style={{ width: "100%" }}
      />
    );
  };

  const overriddenTitleBodyTemplate = (rowData: YAxisIdentifierWithOverriddenTitle) => {
    return <div>{rowData.overriddenTitle}</div>;
  };

  const onRowEditComplete = (e: DataTableRowEditCompleteParams): void => {
    const { newData, index } = e;

    if (newData && index !== undefined && index !== null) {
      const updatedIdentifiers = [...identifiers];
      updatedIdentifiers[index] = { ...newData };
      setIdentifiers(updatedIdentifiers);
      setCurrentConfig(updatedIdentifiers);
    } else {
      console.error("Invalid edit event data:", e);
    }
  };

  const handleRowReorderEvt = (e: any) => {
    const reorderedData = [...identifiers];
    const [removed] = reorderedData.splice(e.from, 1);
    reorderedData.splice(e.to, 0, removed);
    setIdentifiers(reorderedData);
    setCurrentConfig(reorderedData);
  };

  return (
    <div>
      <DataTable
        value={identifiers}
        onRowEditComplete={onRowEditComplete}
        editMode="row"
        onRowReorder={handleRowReorderEvt}
        reorderableRows
      >
        <Column
          field="identifier"
          header="Title"
          body={titleBodyTemplate}
          style={{ width: "50%" }}
        />
        <Column
          className="p-0"
          field="overriddenTitle"
          header="Overridden Title"
          alignHeader="left"
          style={{ width: "30%", textAlign: "left" }}
          align="center"
          editor={options => textEditor(options)}
          body={overriddenTitleBodyTemplate}
        />
        <Column rowEditor align="center" style={{ width: "10%" }} />
      </DataTable>
    </div>
  );
};

export default ChartIdentifiersEditor;
